const _excluded = ["collectionSettings", "templates"];var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var s = Object.getOwnPropertySymbols(e);for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (e.includes(n)) continue;t[n] = r[n];}return t;} /* eslint-disable max-statements */
import React from 'react';
import { connect } from 'react-redux';
import { Loader } from '@googlemaps/js-api-loader';

import { LMap } from "./index";

import { ErrorBoundary } from "../V2/Components/ErrorHandling";















const mapStateToProps = ({ settings, templates }) => ({
  collectionSettings: settings.collection,
  templates
});

const connector = connect(mapStateToProps);




const MapComponent = (_ref) => {var _collectionSettings$g, _collectionSettings$g2;let { collectionSettings, templates } = _ref,props = _objectWithoutProperties(_ref, _excluded);
  const startingPoint = (collectionSettings === null || collectionSettings === void 0 ? void 0 : (_collectionSettings$g = collectionSettings.get('mapStartingPoint')) === null || _collectionSettings$g === void 0 ? void 0 : _collectionSettings$g.toJS()) || [
  { lat: 46, lon: 6 }];

  const tilesProvider = (collectionSettings === null || collectionSettings === void 0 ? void 0 : collectionSettings.get('tilesProvider')) || 'mapbox';
  const mapApiKey = collectionSettings === null || collectionSettings === void 0 ? void 0 : collectionSettings.get('mapApiKey');
  let mapLayers = props.layers || (collectionSettings === null || collectionSettings === void 0 ? void 0 : (_collectionSettings$g2 = collectionSettings.get('mapLayers')) === null || _collectionSettings$g2 === void 0 ? void 0 : _collectionSettings$g2.toJS());

  if (tilesProvider === 'google') {var _mapLayers;
    mapLayers = (_mapLayers = mapLayers) === null || _mapLayers === void 0 ? void 0 : _mapLayers.filter((layer) => layer !== 'Dark');
  }

  if (tilesProvider === 'google' && mapApiKey) {
    const loader = new Loader({
      apiKey: mapApiKey,
      retries: 0
    });
    loader.
    load().
    then(() => {}).
    catch(() => {});
  }

  const templatesInfo = templates.reduce(
    (info, t) => _objectSpread(_objectSpread({},
    info),
    t ?
    {
      [t.get('_id')]: {
        color: t.get('color'),
        name: t.get('name')
      }
    } :
    {}),

    {}
  );
  const mapProps = _objectSpread(_objectSpread({},
  props), {}, {
    startingPoint,
    tilesProvider,
    mapApiKey,
    templatesInfo,
    layers: mapLayers });

  return (/*#__PURE__*/
    _jsx(ErrorBoundary, {}, void 0, /*#__PURE__*/
    React.createElement(LMap, mapProps)
    ));

};

const container = connector(MapComponent);
export { container as Map };